// extracted by mini-css-extract-plugin
export default {"ItemContainer":"TeamListItem_ItemContainer__k6ShT","TeamDetails":"TeamListItem_TeamDetails__2JzbZ"};